import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectGoogleTagManagerId } from '~/shared/store/common/selects'

const GTM_CUSTOM_PATH = '/gtg-mygrowth/'

export const useGoogleTagManager = (): void => {
  const googleTagManagerId = useSelector(selectGoogleTagManagerId)

  const initGTM = useCallback(() => {
    const script = document.createElement('script')
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        '${GTM_CUSTOM_PATH}?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${googleTagManagerId}');`

    script.async = true
    document.body.appendChild(script)
  }, [googleTagManagerId])

  useEffect(() => {
    if (!googleTagManagerId) return
    if (window.location.hostname === 'localhost') return

    initGTM()
  }, [googleTagManagerId, initGTM])
}
